import api from '@/services/api'
import getUrlParameter from '@/utils/getUrlParameter'
import denormalize from '@/utils/denormalizeResponse'
import connectRelations from '@/utils/connectRelations'
import schema from '@/resource/schema'

export async function fetchAthlete({ commit }, userId) {
    const response = await api.get(`/api/v2/resources/athletes/${userId}`, {
        query: {
            include: {
                '@fragments': ['athlete-profile:basics'],
                'eventBeaconVideoCount': true,
                'similarUncommittedAthletesCount': true,
            },
        },
    });
    const { root: athlete, resources } = denormalize(response)

    connectRelations(resources, schema)

    commit('loadAthleteSuccess', athlete);
}

export async function bootstrapAthlete({ commit }, athleteData) {
    const { root: athlete, resources } = denormalize(athleteData)

    connectRelations(resources, schema)

    commit('videoLibrary/setUrlSlug', athlete.urlSlug, { root: true })
    commit('loadAthleteSuccess', athlete);
}

export async function fetchEvents({ commit }, userId) {
    const response = await api.get(`/api/v2/resources/athletes/${userId}`, {
        query: {
            include: {
                '@fragments': ['athlete-profile:events'],
            },
        },
    });

    const { root: { events }, resources } = denormalize(response)

    connectRelations(resources, schema)

    commit('loadAthleteEventsSuccess', events);
}

export async function fetchVideos({ commit }, userId) {
    const response = await api.get(`/api/v2/resources/athlete-videos`, {
        query: {
            include: {
                '@fragments': ['athlete-profile:player-videos']
            },
            '@paginate': {
                limit: 2000,
                offset: 0 //(page * 100) || 0
            },
            filter: {
                userId: userId,
                active: 1
            }
        }
    });

    const denormalized = denormalize(response)

    connectRelations(denormalized.resources, schema)

    commit('loadAthleteVideosSuccess', denormalized.root);
}

export async function bootstrapVideos({ commit }, videoData) {
    const { root: { videos }, resources } = denormalize(videoData)

    connectRelations(resources, schema)

    commit('loadAthleteVideosSuccess', videos);
}


export async function favorite({ commit, getters: { athleteId, skips }, rootGetters }) {
    const stashedSkips = skips

    commit('favoriteStart', {
        createdDate: new Date(),
        creator: {
            id: rootGetters['userData/userId'],
        },
    })

    try {
        const response = await api.post('/api/v2/athlete-favorites', {
            athleteId,
            location: 'profile',
            query: {
                include: {
                    createdDate: true,
                    creator: {
                        firstName: true,
                        lastName: true,
                    },
                },
            },
        })

        const { root: favorite } = denormalize(response)

        commit('favoriteSuccess', {...favorite, athleteId})
    } catch (e) {
        console.error(e)
        commit('favoriteFailure', { skips: stashedSkips })
    }
}

export async function skip({ commit, getters: { athleteId, favorites }, rootGetters }) {
    const stashedFavorites = favorites

    commit('skipStart', {
        createdDate: new Date(),
        creator: {
            id: rootGetters['userData/userId'],
        },
    })

    try {
        const response = await api.post('/api/v2/skips', {
            athleteId,
            location: 'profile',
            query: {
                include: {
                    createdDate: true,
                    creator: {
                        firstName: true,
                        lastName: true,
                    },
                },
            },
        })

        const { root: skip } = denormalize(response)

        commit('skipSuccess', {...skip, athleteId})
    } catch (e) {
        console.error(e)
        commit('skipFailure', { favorites: stashedFavorites })
    }
}

export async function sendFeedbackRequest({ commit, getters }, { type, body, organization, source }) {
    const { athleteId, userFullName, urlSlug } = getters

    const subject = type === 'video'
        ? `Video Request for ${userFullName}`
        : `Recommendation Request for ${userFullName}`

    const key = getUrlParameter('k')

    try {
        commit('feedbackRequestStart')

        await api.post(`/api/v1/${key ? 'temp' : 'mail'}/draft`, {
            key,
            urlname: urlSlug,
            attachments: [],
            feedback_request: {
                club_id: organization.id,
                player_user_id: athleteId,
                feedback_type: type,
                source: source,
            },
            subject,
            body,
            send: true,
        })

        commit('feedbackRequestSuccess')
    } catch (e) {
        console.error(e)
        commit('feedbackRequestFailure')
    }
}

export async function downloadDocument({ commit }, document) {
    const { url } = await api.get(`/api/v2/documents/${document.id}/download`)
    window.location.href = url
}